/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionUsersPagedList } from '../../models/subscription-users-paged-list';

export interface GetUsersOfSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
}

export function getUsersOfSubscription(http: HttpClient, rootUrl: string, params: GetUsersOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionUsersPagedList>> {
  const rb = new RequestBuilder(rootUrl, getUsersOfSubscription.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionUsersPagedList>;
    })
  );
}

getUsersOfSubscription.PATH = '/subscriptions/{uid}/users';
